module.exports = __webpack_public_path__ + "img/image1.a72df28c.jpg";